import { render, staticRenderFns } from "./ChallengeOfTheWeek.vue?vue&type=template&id=49788a30&scoped=true"
import script from "./ChallengeOfTheWeek.vue?vue&type=script&lang=js"
export * from "./ChallengeOfTheWeek.vue?vue&type=script&lang=js"
import style0 from "./ChallengeOfTheWeek.vue?vue&type=style&index=0&id=49788a30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49788a30",
  null
  
)

export default component.exports